import { doc, getDoc, getFirestore } from 'firebase/firestore';

export type StaffAccessResult =
  | { status: 'granted' }
  | { status: 'denied'; reason: 'signed_out' | 'missing_user_doc' | 'missing_staff_hosting' }
  | { status: 'retryable_error'; message: string };

export async function checkStaffAccess(user: { uid: string } | null): Promise<StaffAccessResult> {
  if (!user) {
    return { status: 'denied', reason: 'signed_out' };
  }

  try {
    const firestore = getFirestore();
    const userSnapshot = await getDoc(doc(firestore, 'users', user.uid));

    if (!userSnapshot.exists()) {
      return { status: 'denied', reason: 'missing_user_doc' };
    }

    const userData = userSnapshot.data();
    const allowedHostings = Array.isArray(userData?.allowedHostings)
      ? userData.allowedHostings
      : [];

    if (allowedHostings.includes('STAFF')) {
      return { status: 'granted' };
    }

    return { status: 'denied', reason: 'missing_staff_hosting' };
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Unknown error';
    return { status: 'retryable_error', message };
  }
}
